import React, { Component } from 'react';
import styles from './style.css';
import {Dummy} from '../';
import * as trends from '../../../trends.js';

export default class Electrotable extends Dummy {

    render() {
        return (
            <div className={'col-md-4'+' '+styles.electro} id={this.props.div_id}>
                <table className={styles.tg}>
                    <tbody>
                    <tr>
                        <th className={styles.caption} colSpan="4">Текущие показания электропитания:</th>
                    </tr>
                    <tr>
                        <th className={styles.caption}></th>
                        <th className={styles.caption}>Фаза А</th>
                        <th className={styles.caption}>Фаза В</th>
                        <th className={styles.caption}>Фаза С</th>
                    </tr>
                    <tr onClick={()=>{this.props.openModal(trends.electro_t1)}} className={styles.hovered}>
                        <td className={styles.caption}>Напряжение (В)</td>
                        {this.getPsValue('ti_6_93_141', 'td', styles.disabled, styles.value)}
                        {this.getPsValue('ti_6_93_142', 'td', styles.disabled, styles.value)}
                        {this.getPsValue('ti_6_93_143', 'td', styles.disabled, styles.value)}
                    </tr>
                    <tr onClick={()=>{this.props.openModal(trends.electro_t2)}} className={styles.hovered}>
                        <td className={styles.caption}>Ток (А)</td>
                        {this.getPsValue('ti_6_93_151', 'td', styles.disabled, styles.value)}
                        {this.getPsValue('ti_6_93_152', 'td', styles.disabled, styles.value)}
                        {this.getPsValue('ti_6_93_153', 'td', styles.disabled, styles.value)}
                    </tr>
                    <tr>
                        <td className={styles.caption}>Коэфф. мощности</td>
                        {this.getPsValue('ti_6_93_161', 'td', styles.disabled, styles.value)}
                        {this.getPsValue('ti_6_93_162', 'td', styles.disabled, styles.value)}
                        {this.getPsValue('ti_6_93_163', 'td', styles.disabled, styles.value)}
                    </tr>
                    <tr>
                        <td className={styles.caption}>Активн. мощн (кВт)</td>
                        {this.getPsValue('ti_6_93_101', 'td', styles.disabled, styles.value)}
                        {this.getPsValue('ti_6_93_102', 'td', styles.disabled, styles.value)}
                        {this.getPsValue('ti_6_93_103', 'td', styles.disabled, styles.value)}
                    </tr>
                    <tr>
                        <td className={styles.caption}>Реакт. мощн (кВар)</td>
                        {this.getPsValue('ti_6_93_121', 'td', styles.disabled, styles.value)}
                        {this.getPsValue('ti_6_93_122', 'td', styles.disabled, styles.value)}
                        {this.getPsValue('ti_6_93_123', 'td', styles.disabled, styles.value)}
                    </tr>
                    </tbody>
                </table>

                <table className={styles.tg}>
                    <tbody>
                    <tr>
                        <th className={styles.caption} colSpan="2">Накопленные показания потребление электроэнергии:</th>
                    </tr>
                    <tr>
                        <th className={styles.caption}></th>
                        <th className={styles.caption}>Энергия</th>
                    </tr>
                    <tr>
                        <td className={styles.caption}>Активаная (кВт*ч)</td>
                        {this.getPsValue('ti_6_93_1', 'td', styles.disabled, styles.value)}
                    </tr>
                    <tr>
                        <td className={styles.caption}>Т1 Активная (кВт*ч)</td>
                        {this.getPsValue('ti_6_93_2', 'td', styles.disabled, styles.value)}
                    </tr>
                    <tr>
                        <td className={styles.caption}>Т2 Активаная (кВт*ч)</td>
                        {this.getPsValue('ti_6_93_3', 'td', styles.disabled, styles.value)}
                    </tr>
                    <tr>
                        <td className={styles.caption}>Т3 Активаная (кВт*ч)</td>
                        {this.getPsValue('ti_6_93_4', 'td', styles.disabled, styles.value)}
                    </tr>
                    <tr>
                        <td className={styles.caption}>Реакт. (кВар*ч)</td>
                        {this.getPsValue('ti_6_93_21', 'td', styles.disabled, styles.value)}
                    </tr>
                    </tbody>
                </table>

            </div>
        );
    }
}

Electrotable.propTypes = {
    div_id: React.PropTypes.string,
};


// WEBPACK FOOTER //
// ./src/components/entries/Electrotable/index.js